<template>
    <div class="vue-events-list-container mx-auto my-4"">
        <div class="mb-3 d-flex flex-wrap justify-content-center">

            <div class="col-12 form-group p-0">
                <label for='vue-events-list-when' class='vue-events-list-dropdown-label'>Show me</label>
                <div class="d-flex justify-content-center">
                    <select name="vue-events-list-when" id='vue-events-list-when' v-on:change="getEvents(true)" class="vue-events-list-filter-dropdown form-control vue-events-list-filter-dropdown-when p-0" v-model="activeDateRefinement">
                        <option v-for='dateRefinement in dateRefinements' :value="dateRefinement.value">{{dateRefinement.label}}</option>
                    </select>
                    <span class="fe fe-chevron-down vue-events-list-filter-arrow"></span>
                </div>
            </div>
<!--            <div class="d-inline-block"><button  v-on:click="getEvents()">Filter</button></div>-->
        </div>

        <div class="vue-events-list-events">
            <div v-if="events.length && !loading" class='blog-posts blog-panel-grid clearfix'>
                <a v-for="(eventPage, index) in events" :href="eventPage.Link" class="blog-post-link position-relative image-overlay image-hover background-cover" :style="{backgroundImage: 'url(' + (index === 0 ? eventPage.FeaturedImageLarge : eventPage.FeaturedImageThumb) + ')'}" :class="{'first': index === 0, 'pos-1': index === 0}">
                    <div class="info-container aspect-inside h-100 d-flex flex-column align-items-center justify-content-center align-items-center align-content-center text-white">
                        <p class="text-center">
                            <span class="event-date-day">{{eventPage.Day}}</span><br>
                            <span class="event-date-month">{{eventPage.Month}}</span>
                        </p>
                        <h3 class="text-white text-center">{{eventPage.Title}}</h3>
                        <div class="text-white read-more ">View event</div>
                    </div>
                </a>
            </div>

            <div class="d-flex justify-content-center pt-4" v-if="showLoadMore">
                <button class='btn btn-primary text-black' :disabled='loadingMore' v-on:click="getEvents(false)">
                    <span class="spinner-border spinner-border-sm" role="status" v-if="loadingMore">
                        <em class="sr-only">Loading...</em>
                    </span>
                    <span v-else>
                        Load more
                    </span></button>
            </div>

            <div v-if="!events.length && !loading" class='py-5 text-center'>
                <p><span class='uil uil-frown text-secondary'></span> Couldn't find any upcoming events. Try <a href='#' v-on:click.prevent="clearFilters">Clearing filters</a> to see all upcoming events.</p>
            </div>
            <div v-if="loading" class='py-5 text-center'>
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: function() {
            return {
                activeCategory: '',
                activeDateRefinement: '',
                events: [],
                loading: false,
                showLoadMore: false,
                loadingMore: false,
                dateRefinements: [
                    {
                        'label': 'All',
                        'value': ''
                    },
                    {
                        'label': 'Today',
                        'value': 'today'
                    },
                    {
                        'label': 'Next 7 days',
                        'value': 'next-7'
                    },
                    {
                        'label': 'Next 30 days',
                        'value': 'next-30'
                    },
                    {
                        'label': 'Next 3 months',
                        'value': 'next-3-months'
                    },
                    {
                        'label': 'Next 6 months',
                        'value': 'next-6-months'
                    },
                    {
                        'label': 'Next 9 months',
                        'value': 'next-9-months'
                    },
                    {
                        'label': 'Next 12 months',
                        'value': 'next-12-months'
                    },
                ]
            };
        },
        props: {
            'eventsSeed': Array,
            'limit': Number,
            'categories': Array,
            'requestUrl': String
        },
        methods: {
            getEvents(replaceExisting) {
                let self = this;
                let params = {
                    // EventCategory: this.activeCategory,
                    When: this.activeDateRefinement
                };

                if (replaceExisting) {
                    this.loading = true;
                } else {
                    this.loadingMore = true;
                    params.Offset = self.events.length;
                }

                axios.get(this.requestUrl, {
                    params
                })
                    .then(function(response) {
                        if (replaceExisting === true) {
                            self.events = response.data;
                        } else {
                            self.events = self.events.concat(response.data);
                        }

                        self.showLoadMore = response.data.length >= self.limit;
                    })
                    .catch(function (error) {
                        self.events = [];
                    })
                .then(function() {
                    self.loading = false;
                    self.loadingMore = false;
                });
            },
            clearFilters() {
                this.activeCategory = '';
                this.activeDateRefinement = '';
                this.getEvents();
            }
        },
        created() {
            this.events = this.eventsSeed;
            if (this.events.length >= this.limit) {
                this.showLoadMore = true;
            }
        }
    };
</script>
